import * as React from 'react'
import { JsonLd } from 'react-schemaorg'
import { usePageContext } from 'src/contexts/page.context'

export const SearchSchema: React.FC = () => {
  const { siteUrl } = usePageContext()
  return (
    <JsonLd<any>
      item={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: siteUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      }}
    />
  )
}
